<div>
  <div class="bg-primary-light">
    <div class="container text-center py-14 lg:py-16">
      <h1 class="text-3xl lg:text-4xl font-semibold mb-1 text-main-900">{{ 'HAIRSTYLES.TITLE' | translate }}</h1>
      <p class="mb-5">{{ 'HAIRSTYLES.SUBTITLE' | translate }}</p>
      <form [formGroup]="searchHairstyleForm" (ngSubmit)="onSubmitForm()"
        class="border-2 border-main-500 bg-white py-4 px-3 lg:py-2.5 rounded-lg mx-auto w-full lg:w-fit">
        <div class="flex flex-col lg:flex-row gap-2">
          <div class="flex flex-1 relative">
            <input type="text" name="hairstyle" id="hairstyle"
              [placeholder]="'HAIRSTYLES.HAIRSTYLE_PLACEHOLDER' | translate" class="h-11 pl-9 pr-4 focus:outline-none"
              formControlName="hairstyle">
            <div class="absolute top-1/2 -translate-y-1/2 left-2.5">
              <icon-search [size]="18" />
            </div>
          </div>
          <div class="flex flex-1 relative">
            <input type="number" name="price" id="price" [placeholder]="'HAIRSTYLES.MAX_PRICE_PLACEHOLDER' | translate"
              class="h-11 pl-10 pr-4 focus:outline-none" formControlName="maxPrice">
            <div class="absolute top-1/2 -translate-y-1/2 left-2.5">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
                <path d="M12 18V6" />
              </svg>
            </div>
          </div>
          <button type="submit" class="px-8 h-11  rounded-full bg-main-500 hover:bg-main-600 text-white text-sm">
            {{ 'HAIRSTYLES.SEARCH_BUTTON' | translate }}
          </button>
          <button type="reset" (click)="onClearForm()"
            class="px-6 h-11  rounded-full bg-gray-100 border border-gray-200 hover:bg-gray-200 text-sm">
            {{ 'HAIRSTYLES.CLEAR_BUTTON' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="bg-white py-10 lg:py-20 px-4 lg:max-w-5xl xl:max-w-6xl mx-auto">
    @if (isLoadingHairstyles()) {
    <div class="min-h-96 grid grid-cols-2 gap-x-2 gap-y-4 lg:grid-cols-3 xl:grid-cols-4">
      @for (item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; track $index) {
      <div class="flex flex-col gap-2">
        <div class="h-52 bg-gray-200 border rounded-lg flex items-center justify-center animate-pulse">
          <icon-customer [size]="40" class="text-gray-400 scale-150" />
          <span class="sr-only">{{ item }}</span>
        </div>
        <div class="flex items-center justify-between animate-pulse">
          <div class="h-3 bg-gray-200 w-[50%] rounded"></div>
          <div class="h-3 bg-gray-200 w-12 rounded"></div>
        </div>
      </div>
      }
    </div>
    } @else if (hairstylesPaginated() == null || hairstylesPaginated()!.data.length === 0) {
    <div class="min-h-64 flex flex-col items-center justify-center">
      <div class="relative h-14 lg:h-16 w-full mb-2">
        <img ngSrc="/icons/not-found-icon.svg" alt="Not Found" fill priority class="w-14 lg:w-16">
      </div>
      <div class="text-xl font-medium">{{ 'HAIRSTYLES.NO_HAIRSTYLES_FOUND' | translate }}</div>
      <div class="text-gray-500">{{ 'HAIRSTYLES.TRY_ADJUSTING' | translate }}</div>
    </div>
    } @else {
    <div class="min-h-96 grid grid-cols-2 gap-x-3 gap-y-6 lg:grid-cols-3 xl:grid-cols-4">
      @for (hairstyle of hairstylesPaginated()!.data | paginate: {
      itemsPerPage: hairstylesPaginated()!.limit,
      totalItems: hairstylesPaginated()!.totalElements,
      currentPage: hairstylesPaginated()!.currentPage,
      }; track $index) {
      <a [routerLink]="['/hairstyles', hairstyle.nom]"
        class="flex flex-col gap-2 cursor-pointer hover:opacity-90 transition-opacity">
        <div
          class="h-52 lg:h-64 relative bg-primary-light border-[3px] border-main-500 rounded-xl overflow-hidden flex items-center justify-center">
          <img [ngSrc]="hairstyle.images[0] || HAIRSTYLE_PLACEHOLDER" [alt]="hairstyle.nom" fill
            class="object-cover object-top">
        </div>
        <div class="px-1 lg:px-2.5">
          <div class="leading-none text-lg text-center lg:text-left">
            {{ hairstyle.nom }}
          </div>
        </div>
      </a>
      }
    </div>

    @if (hairstylesPaginated()!.totalPages > 1) {
    <pagination-controls [nextLabel]="'HAIRSTYLES.NEXT' | translate" [previousLabel]="'HAIRSTYLES.PREVIOUS' | translate"
      (pageChange)="onPageChange($event)" class="pagination" />
    }
    }
  </div>
</div>
